import React from "react";
import classes from "./SpeakerCard.module.css";

interface Props {
    img: string;
    fullName: string;
    position: string;
    imgAlt?: string;
    onClick?: (value?: any) => void;
}

const SpeakerCard = ({ img, imgAlt, fullName, position, onClick }: Props) => {
    return (
        <div className={classes.speakers__cardWrapper} onClick={onClick}>
            <div className={classes.speakers__card}>
                <img className={classes.speakers__cardImage} src={img} alt={imgAlt ? imgAlt : fullName} loading="lazy"/>
                <div>
                    <b className={"gradientStyle"}>{fullName}</b>
                    <br />
                    <span data-title={position}>{position}</span>
                </div>
            </div>
        </div>
    );
};

export default SpeakerCard;
